import ActionCardGridView from "@/components/actions/ActionCardGridView";
import { useSiteName } from "@/hooks/useSiteName";
import { Action, ActionService } from "@/services/ActionService";
import { useEffect, useState } from "react";
import { useParams } from "react-router";

const SiteActionListPage: React.FC = () => {
  const [actionList, setActionsList] = useState<Action[]>([]);
  const params = useParams();
  const { siteName } = useSiteName(params.siteId);
  
  useEffect(() => {
    ActionService
      .getByASiteId(params.siteId!)
      .then(setActionsList);
  }, [params.siteId]);

  return (
    <div className="container mx-auto p-4">
      <ActionCardGridView actionsList={actionList} title={`Site: ${siteName}`} />
    </div>
  );
};

export default SiteActionListPage;
